module.exports = __webpack_public_path__ + "static/media/background.66606de0.jpg";